import { useAuth } from '@/providers/AuthProvider';
import { Navigate, Outlet } from 'react-router';

export const PublicRoute = () => {
  const { user, isAuthenticated, authLoading } = useAuth();

  if (authLoading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  if (isAuthenticated) {
    const dashboardPath =
      user?.role === 'ADMIN' ? '/admin/dashboard' : '/crew/dashboard';

    return <Navigate to={dashboardPath} replace />;
  }

  return <Outlet />;
};
